// /**
//  * منافذ التطوير المحلي:
//  * CuraLab → :4200 | HR → :4201 | Insurance → :4300 | واجهة البوابة (Angular) → :52395
//  */
// export const environment = {
//   production: false,
//   apiBase: 'https://localhost:5002',
//   auth: {
//     tokenEndpoint: 'https://localhost:5002/connect/token',
//     clientId: 'spa_local',
//     scope: 'openid profile email offline_access hr curalab lab'
//   },
//   systemUrls: {
//     auth: 'http://localhost:52395',
//     lab: 'http://localhost:4200',
//     hr: 'http://localhost:4201',
//     insurance: 'http://localhost:4300',
//   } as Record<string, string>,
//   /** صفحة التطبيقات المتاحة في البوابة (بعد رفض وصول نظام معيّن) */
//   authPortalAppsUrl: 'http://localhost:52395/#/',

//   /** سلسلة تسجيل خروج موحّد: مسح التخزين المحلي في Lab وHR ثم صفحة الدخول */
//   ssoLogout: {
//     enabled: true,
//     labLogoutUrl: 'http://localhost:4200/#/logout-callback',
//     hrLogoutUrl: 'http://localhost:4201/#/logout-callback',
//     insuranceLogoutUrl: 'http://localhost:4300/logout-callback',
//     gatewayLogoutUrl: 'http://localhost:52395/logout-callback',
//     gatewayLoginUrl: 'http://localhost:52395/login',
//   },
// };

export const environment = {
  production: true,
  apiBase: 'https://authportal.curalab.ps/Core',
  auth: {
    tokenEndpoint: 'https://authportal.curalab.ps/Core/connect/token',
    clientId: 'authportal_prod',
    scope:
      'openid profile email offline_access hr curalab lab patient doctor referrallab',
  },
  systemUrls: {
    auth: 'https://authportal.curalab.ps/Auth',
    lab: 'https://curalab.ps',
    hr: 'https://curalab.ps',
    insurance: 'https://insurance.curalab.ps',
    patient: 'https://curalab.ps/Patient/',
    doctor: 'https://curalab.ps/Doctor/',
    referrallab: 'https://curalab.ps/External/',
  } as Record<string, string>,

  /** سلسلة تسجيل خروج موحّد: مسح التخزين المحلي في Lab وHR ثم صفحة الدخول */
  ssoLogout: {
    enabled: true,
    labLogoutUrl: 'https://curalab.ps/#/logout-callback',
    hrLogoutUrl: 'https://curalab.ps/#/logout-callback',
    insuranceLogoutUrl: 'https://insurance.curalab.ps/logout-callback',
    gatewayLogoutUrl: 'https://authportal.curalab.ps/Auth/logout-callback',
    gatewayLoginUrl: 'https://authportal.curalab.ps/Auth/login',
  },
};
